import axios from '@/libs/api.request'

export const getPagedCompanies = (page, limit) => {
  return axios.request({
    url: `companies`,
    method: 'get',
    params: {
      page,
      limit
    }
  })
}

export const queryCompanies = (keyword, tags, page, size) => {
  if (tags !== null) {
    return axios.request({
      url: `search/company`,
      method: 'get',
      params: {
        q: keyword,
        filters: {
          tags
        },
        page,
        size
      }
    })
  } else {
    return axios.request({
      url: `search/company`,
      method: 'get',
      params: {
        q: keyword,
        page,
        size
      }
    })
  }
}

export const addCompany = (data) => {
  return axios.request({
    url: `companies/create`,
    method: 'post',
    data
  })
}

export const updateSingleCompany = (id, data) => {
  return axios.request({
    url: `companies/${id}`,
    method: 'put',
    data
  })
}

export const deleteSingleCompany = (id) => {
  return axios.request({
    url: `companies/${id}`,
    method: 'delete'
  })
}
